import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import TagEditor from 'appSrc/components/Tag/Editor';
import { FormTextField, FormSelect, FormTextArea, FormToggle } from 'appSrc/components/UI/ReduxForm';
import { VideoImageSelector } from 'appSrc/components/Shards';
import { PrimaryButton, Icon } from 'appSrc/components/UI';
import CategorySelectModal from 'appSrc/AdminPanel/pages/Modals/Category/Select';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import TheaterPlayIcon from 'appSrc/components/Shards/Theater/PlayIcon';
import style from './styles/style.module.css';


class ListForm extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            selectedImage: this.props.initialValues.coverImage,
            categories: this.props.initialValues.categories,
            youtubeId: this.props.initialValues.youtube,
        };
    }
    updateCover = ( values ) => {
        var imageData = values.selectedImage;
        var youtubeId = values.youtubeId;
        if( imageData != null ) {
            this.props.changeFieldValue( 'coverImage', imageData );
            this.props.changeFieldValue( 'youtube', youtubeId );
        }
        this.setState( {
            selectedImage: imageData,
            youtubeId: youtubeId,
            showCoverModal: false,
        } );
    }
    updateCategories = ( { checked, data } ) => {
        this.categoryIds = checked;
        this.props.changeFieldValue( 'categories', data );

        this.setState( {
            categories: data,
            showCategorySelect: false,
        } );
    }
    submitHandler = ( values ) => {
        values = { ...values };
        values.categoryIds = this.categoryIds;
        var tagObjects = this.tagEditor.getTagResults();
        this.props.onSubmit( { list: { ...values }, tags: tagObjects } );
    }



    render() {
        const { handleSubmit } = this.props;
        const { selectedImage, youtubeId, categories } = this.state;


        return (
            <Form
            className={ style.listForm }
            onSubmit={ handleSubmit( this.submitHandler ) }>
                <div className={ style.topLevel }>
                    <div className={ style.imageWrapper }
                    onClick={ () => { this.setState( { showCoverModal: true } ); } }>
                        <ListCoverImage coverImage={ selectedImage } />
                        { youtubeId &&
                            <TheaterPlayIcon className={ style.playIcon } youtubeId={ youtubeId } />
                        }
                        <span className={ style.editWrapper }>
                        EDIT<Icon source='fontAwesome' icon='fas/faPencilAlt' />
                        </span>
                    </div>
                    <div className={ style.detailsWrapper }>
                        <Field
                        id="title"
                        name="title"
                        label="Title"
                        component={ FormTextField }
                        fullWidth />
                        <Field
                        id="slug"
                        name="slug"
                        label="Slug"
                        component={ FormTextField }
                        fullWidth />
                        <Field
                        id="description"
                        name="description"
                        component={ FormTextArea }
                        multiLine={ true }
                        label="Description"
                        fullWidth />
                        <Field
                        id="interestId"
                        name="interestId"
                        label="Channel"
                        component={ FormSelect }
                        underlineShow={true}
                        options={ [
                            { text: 'none', value: null },
                            ...this.props.listInterests.map( interest => ( {
                                text: interest.interest,
                                value: interest.interestid,
                            } ) ),
                        ] } />

                        <div className={ style.categoriesField } >
                            <div className={ style.fieldTitle }>Categories:</div>
                            <p onClick={ () => { this.setState( { showCategorySelect: true } ); } }>{ categories.map( category => category.name ).join( ', ' ) }</p>
                        </div>

                        <TagEditor
                        label='Tags'
                        style={ { marginTop: '15px', maxWidth: '350px' } }
                        currentTags={ this.props.initialValues.tags ? this.props.initialValues.tags : [] }
                        childRef={ ( el ) => { this.tagEditor = el; } } />

                        <Field
                        id="published"
                        name="published"
                        label="Published"
                        component={ FormToggle }
                        style={ { marginTop: '10px' } } />
                        <Field
                        id="deactivated"
                        name="deactivated"
                        label="Deactivated"
                        component={ FormToggle }
                        style={ { marginTop: '10px' } } />
                        <Field
                        id="rankedList"
                        name="rankedList"
                        label="Featured"
                        component={ FormToggle }
                        style={ { marginTop: '10px' } } />

                        <PrimaryButton
                        label="Submit"
                        fullWidth
                        type="submit"
                        style={ { marginTop: '45px' } }/>
                    </div>
                </div>
                { this.state.showCoverModal &&
                    <VideoImageSelector title='Cover Image Options'
                    initialValues={ { selectedImage: selectedImage, youtube: `https://www.youtube.com/watch?v=${ this.props.initialValues.youtube }` } }
                    closeHandler={ () => { this.setState( { showCoverModal: false } ); } }
                    onSubmit={ this.updateCover } />
                }
                { this.state.showCategorySelect &&
                    <CategorySelectModal initialValues={ this.props.initialValues.categories }
                    onSubmit={ this.updateCategories }
                    closeHandler={ () => { this.setState( { showCategorySelect: false } ); } } />
                }
            </Form>
        );
    }
}

ListForm = reduxForm( {
    form: 'ListForm',
} )( ListForm );

const mapStateToProps = ( state ) => {
    return {
        listInterests: state.vars.interests,
        categoryTree: state.vars.admin.categoryTree,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'ListForm', field, value ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( ListForm );
